export const PROJECTS = [
  {
    "id": 1,
    "title": "CareerVue: Job Portal Website",
    "tech": "MongoDB, Express.js, React,  Node.js",
    "description": "A comprehensive career platform with intelligent analytics, job listings, CV creation, and government job opportunities.",
    "github": "https://github.com/pranavmalwatkar/careervue",
    "liveDemo": "https://github.com/pranavmalwatkar/careervue",
    "image": "./assets/images/careervue_homepage.png",
    "category": "MERN Stack",
    "status": "completed"
  },
  {
    "id": 2,
    "title": "Scientific Calculator",
    "tech": "HTML5, CSS3, JavaScript, Math.js",
    "description": " This calculator provides both basic arithmetic operations and advanced scientific functions in a clean, responsive interface.",
    "github": "https://github.com/pranavmalwatkar/Calculator?tab=readme-ov-file",
    "liveDemo": "https://calculator-six-ruddy-15.vercel.app/",
    "image": "./assets/images/calculator.png",
    "category": "Frontend",
    "status": "completed"
  }
  // ,
  // {
  //   "id": 3,
  //   "title": "College Website Clone",
  //   "tech": "HTML, CSS, React.js",
  //   "description": "A clone of a college website, showcasing frontend development skills.",
  //   "github": "https://github.com/PankajNarwade28/ReactCollegeWebpage",
  //   "liveDemo": "https://react-pankajnarwade28.netlify.app/",
  //   "image": "./assets/images/collegereact.jpg",
  //   "category": "Frontend",
  //   "status": "planning"
  // },
  // {
  //   "id": 4,
  //   "title": "Quiz App",
  //   "tech": "React.js",
  //   "description": "An interactive quiz application for testing knowledge, built with React.",
  //   "github": null,
  //   "liveDemo": null,
  //   "image": "./assets/images/quiz.jpg",
  //   "category": "Frontend",
  //   "status": "in-progress"
  // },
  // {
  //   "id": 5,
  //   "title": "Cocktail's Bar Webpage",
  //   "tech": "Html, CSS, JS",
  //   "description": "A dynamic webpage for a cocktail bar, using an external API to fetch data.",
  //   "github": "https://github.com/PankajNarwade28/Cocktail-s_Bar",
  //   "liveDemo": "https://cocktailsbarbypankaj.netlify.app/",
  //   "image": "./assets/images/bar.jpg",
  //   "category": "Frontend",
  //   "status": "completed"
  // },
  // {
  //   "id": 6,
  //   "title": "Parallax App",
  //   "tech": "HTML, CSS, React.js",
  //   "description": "A showcase of the parallax scrolling effect, demonstrating advanced CSS techniques.",
  //   "github": null,
  //   "liveDemo": null,
  //   "image": "./assets/images/parallax.jpg",
  //   "category": "Frontend",
  //   "status": "completed"
  // }, 
  // {
  //   "id": 7,
  //   "title": "User Management System",
  //   "tech": "HTML, CSS, Mysql , express.js, Node.js",
  //   "description": "A user management system built with Node.js and Express, featuring user authentication and role-based access.",
  //   "github": "https://github.com/PankajNarwade28/UserManagementApp.PDN.in",
  //   "liveDemo": null,
  //   "image": "./assets/images/usermg.jpg",
  //   "category": "backend",
  //   "status": "completed"
  // },
  // {
  //   "id":8,
  //   "title": "Online Voting System",
  //   "tech": "JSP, Servlet , MySQL, Tomcat",
  //   "description": "An online voting system built with JSP and Servlets, featuring user authentication and vote management.",
  //   "github": "https://github.com/PankajNarwade28/Online-Voting-System",
  //   "liveDemo": null,
  //   "image": "./assets/images/voting.jpg",
  //   "category": "Full Stack",
  //   "status": "completed"
  // }, 
  // {
  //   "id":9,
  //   "title": "Rock Paper Scissors Game",
  //   "tech": "JS, HTML, CSS",
  //   "description": "A classic Rock Paper Scissors game built with JavaScript, testing strategy and decision-making.",
  //   "github": "https://github.com/PankajNarwade28/Stone-Paper-Scissor-JS",
  //   "liveDemo": "https://stone-paper-scissor-js-pdn.netlify.app/",
  //   "image": "./assets/images/rockpaper.jpg",
  //   "category": "frontend",
  //   "status": "completed"
  // },
  // {
  //   "id": 10,
  //   "title": "College Website Clone ",
  //   "tech": "HTML, CSS, Js , Github Pages",
  //   "description": "A clone of a college website, showcasing frontend development skills.",
  //   "github": "https://github.com/PankajNarwade28/GsgCollegePDN.edu.in",
  //   "liveDemo": "https://pankajnarwade28.github.io/GsgCollegePDN.edu.in/",
  //   "image": "./assets/images/gsg.jpg",
  //   "category": "Frontend",
  //   "status": "completed"
  // },
];